// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#hour-preparation-tabs-class[data-v-75ffc638]  .nav-pills .nav-link{font-size:16px;color:#3da5de;border:1px solid #3da5de;border-radius:.358rem;margin:0 4px}#hour-preparation-tabs-class[data-v-75ffc638]  .nav-pills .nav-link.active{color:#fff}", ""]);
// Exports
module.exports = exports;
